import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch, placeholder = "Buscar artículos, temas, referencias..." }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSearch = (value) => {
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
    setIsExpanded(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Input
          type="search"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => handleSearch(e?.target?.value)}
          onFocus={() => setIsExpanded(true)}
          className="pl-12 pr-12 py-4 text-lg bg-warm-parchment border-2 border-transparent focus:border-primary focus:bg-card literary-transition"
        />
        
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          <Icon name="Search" size={20} className="text-scholarly-gray" />
        </div>
        
        {searchTerm && (
          <button
            onClick={handleClear}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1 rounded-full hover:bg-muted literary-transition"
          >
            <Icon name="X" size={16} className="text-scholarly-gray" />
          </button>
        )}
      </div>
      {isExpanded && !searchTerm}
      {isExpanded && (
        <div
          className="fixed inset-0 z-0"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </div>
  );
};

export default SearchBar;